import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdminReportsFilterState {
	districtFilter: number;
	schoolFilter: number;
	teacherFilter: number;
	courseFilter: number;
	activeSubTab: string | null;
}

const initialState: AdminReportsFilterState = {
	districtFilter: 0,
	schoolFilter: 0,
	teacherFilter: 0,
	courseFilter: 0,
	activeSubTab: null,
};

const adminReportsFilterSlice = createSlice({
	name: "adminReportsFilter",
	initialState,
	reducers: {
		setDistrictFilter: (state, action: PayloadAction<number>) => {
			// Only reset dependent filters if district actually changed
			if (state.districtFilter !== action.payload) {
				state.districtFilter = action.payload;
				// Reset dependent filters when district changes
				state.schoolFilter = 0;
				state.teacherFilter = 0;
				state.courseFilter = 0;
			}
		},
		setSchoolFilter: (state, action: PayloadAction<number>) => {
			// Only reset dependent filters if school actually changed
			if (state.schoolFilter !== action.payload) {
				state.schoolFilter = action.payload;
				// Reset dependent filters when school changes
				state.teacherFilter = 0;
				state.courseFilter = 0;
			}
		},
		setTeacherFilter: (state, action: PayloadAction<number>) => {
			// Only reset course filter if teacher actually changed
			if (state.teacherFilter !== action.payload) {
				state.teacherFilter = action.payload;
				// Reset course filter when teacher changes
				state.courseFilter = 0;
			}
		},
		setCourseFilter: (state, action: PayloadAction<number>) => {
			state.courseFilter = action.payload;
		},
		setActiveSubTab: (state, action: PayloadAction<string>) => {
			state.activeSubTab = action.payload;
		},
		resetFilters: (state) => {
			state.districtFilter = 0;
			state.schoolFilter = 0;
			state.teacherFilter = 0;
			state.courseFilter = 0;
			state.activeSubTab = null;
		},
	},
});

export const {
	setDistrictFilter,
	setSchoolFilter,
	setTeacherFilter,
	setCourseFilter,
	setActiveSubTab,
	resetFilters,
} = adminReportsFilterSlice.actions;

export default adminReportsFilterSlice.reducer;
